import { mutatorAction } from 'satcheljs';
import { CompositeEditorViewState } from '../store/schema/CompositeEditorViewState';

// This is to workaround a behavior in Edge/IE
// See VSO 15323 for more details
export default mutatorAction(
    'setIsFocusWorkaroundDivShown',
    function setIsFocusWorkaroundDivShown(viewState: CompositeEditorViewState, isShown: boolean) {
        viewState.isFocusWorkaroundDivShown = isShown;
    }
);
